module.exports = __webpack_public_path__ + "img/groupNull.49a68f25.png";